import apiFetch from './api';
import localSendersData from '../senders.json';
import localReceiversData from '../receivers.json';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;
const USE_LOCAL_CONTACT_JSON = false;

function normalizeListPayload(data) {
  return data?.data || (Array.isArray(data) ? data : []);
}

async function fetchAgentsFromApi() {
  const userId = sessionStorage.getItem('user_id');
  if (!userId) {
    throw new Error('No user_id found in sessionStorage');
  }

  const response = await apiFetch(
    `${API_BASE_URL}/api/items/agents?filter%5Buser_id%5D%5B_eq%5D=${userId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch agents');
  }

  const data = await response.json();
  return normalizeListPayload(data);
}

async function fetchSendersFromApi(forceApi = false) {
  if (USE_LOCAL_CONTACT_JSON && !forceApi) {
    return localSendersData;
  }

  const userId = sessionStorage.getItem('user_id');
  if (!userId) {
    throw new Error('No user_id found in sessionStorage');
  }

  const response = await apiFetch(
    `${API_BASE_URL}/api/items/senders?filter%5Buser_id%5D%5B_eq%5D=${userId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch senders');
  }

  const data = await response.json();
  return normalizeListPayload(data);
}

async function fetchReceiversFromApi(forceApi = false) {
  if (USE_LOCAL_CONTACT_JSON && !forceApi) {
    return localReceiversData;
  }

  const userId = sessionStorage.getItem('user_id');
  if (!userId) {
    throw new Error('No user_id found in sessionStorage');
  }

  const response = await apiFetch(
    `${API_BASE_URL}/api/items/receivers?filter%5Buser_id%5D%5B_eq%5D=${userId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch receivers');
  }

  const data = await response.json();
  return normalizeListPayload(data);
}

/**
 * @param {import('redux').Dispatch} dispatch
 * @returns {Promise<{ success: boolean, error?: string }>}
 */
export async function refreshAgents(dispatch) {
  try {
    const agentsData = await fetchAgentsFromApi();
    dispatch({ type: 'SET_AGENTS', payload: agentsData });
    return { success: true };
  } catch (err) {
    console.error('Error refreshing agents:', err.message);
    return { success: false, error: err.message };
  }
}

/**
 * @param {import('redux').Dispatch} dispatch
 * @returns {Promise<{ success: boolean, error?: string }>}
 */
export async function refreshSenders(dispatch) {
  try {
    const sendersData = await fetchSendersFromApi(true);
    dispatch({ type: 'SET_SENDERS', payload: sendersData });
    return { success: true };
  } catch (err) {
    console.error('Error refreshing senders:', err.message);
    return { success: false, error: err.message };
  }
}

/**
 * @param {import('redux').Dispatch} dispatch
 * @returns {Promise<{ success: boolean, error?: string }>}
 */
export async function refreshReceivers(dispatch) {
  try {
    const receiversData = await fetchReceiversFromApi(true);
    dispatch({ type: 'SET_RECEIVERS', payload: receiversData });
    return { success: true };
  } catch (err) {
    console.error('Error refreshing receivers:', err.message);
    return { success: false, error: err.message };
  }
}

/**
 * @param {import('redux').Dispatch} dispatch
 * @returns {Promise<{ success: boolean, error?: string }>}
 */
export async function refreshSendersAndReceivers(dispatch) {
  const sendersResult = await refreshSenders(dispatch);
  const receiversResult = await refreshReceivers(dispatch);
  return {
    success: sendersResult.success && receiversResult.success,
    error: sendersResult.error || receiversResult.error,
  };
}

export { fetchAgentsFromApi, fetchSendersFromApi, fetchReceiversFromApi };
